module.exports = __webpack_public_path__ + "static/media/joelhocalabresa.c68f0a62.webp";